<template>
    <div class="row d-flex align-items-end wrapper mt-5 pb-3">
        <div class="col-12 col-sm-3 d-none d-sm-block">
            <img :src="kotoriImg" class="img-fluid rounded popper1"/>
        </div>
        <div class="col-12 col-sm-9">
            <div class="row justify-content-center align-items-start">
                <img :src="kotoriImg"
                     class="kotori img-fluid rounded col-3 d-block d-sm-none d-md-none d-lg-none popper2"/>
                <h2 class="mt-5 mb-4 mb-sm-3 mt-sm-3 mb-lg-4 text-kotori col col-sm-12 text-center">{{ $t('title') }}</h2>
            </div>
            <div class="row justify-content-center form-pc">
                <input ref="urlInput" @click="urlInputOnClick" @keypress.enter="urlInputOnClick"
                       class="col-12 col-sm-9 url-input form-control-lg mr-md-3"
                       type="text" :placeholder="$t('placeHolder')" value="" v-model="inputUrl"/>
                <button class="col-12 col-sm-2 btn btn-kawaii text-white"
                        @click="getShortUrl" id="get-url-btn">{{ buttonText }}
                    <div id="get-url-loader" class="loader" style="display: none;"></div>
                </button>
            </div>
        </div>
        <div class="col-12 col-sm-9 offset-sm-3">
            <div v-for="(shortUrl, index) in shortUrls" class="mt-1 mt-md-3">
                <div class="alert alert-trans alert-success" role="alert" :id="'shortUrl-' + index">
                    <a :href="shortUrl" target="_blank">{{ shortUrl }}</a>
                    <a class="clipboard-a" href="#" :data-clipboard-text="shortUrl">
                        <i class="fa fa-chain">{{ $t('copy') }}</i>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<i18n>
en:
  title: "Shorten Your URL"
  placeHolder: "https://some.url"
  empty: "Please input a URL~"
  already: "It's already shortened~"
  unknown: "Unknown error chun~"
  toFast: "Request too frequently, have a rest~"
  copy: "Copy"
  copied: "Copied~"
  failToCopy: "Failed to copy, QAQ"
zh:
  title: "生成短网址"
  placeHolder: "https://某个.网址"
  empty: "请填写网址啾～"
  already: "已经是短网址啦～"
  unknown: "未知错误啾～"
  toFast: "太快啦，休息一下吧啾啾～"
  copy: "复制网址"
  copied: "复制成功啾～"
  failToCopy: "复制失败啾～请尝试手动复制～"
</i18n>

<script>
    import config from "./config";
    import urlEncode from "./buildUrlParam";
    // import ClipboardJS from "clipboard";

    export default {
        data() {
            return {
                kotoriImg: require('./kotori.png'),
                selectCooldown: false,
                inputUrl: "",
                shortUrls: [],
                errorMsg: "",
                successMsg: "",
                buttonText: "Shorten!",
                cb: null,
            }
        },
        methods: {
            showError(dom, msg, place) {
                if (!dom.is(":visible"))
                    return;
                dom.popover({
                    content: msg,
                    placement: place,
                    template: '<div class="popover"><div class="arrow"></div>' +
                    '<div class="popover-body">' +
                    '</div></div>',
                    delay: {
                        "show": 500,
                        "hide": 500,
                    }
                });
                dom.popover('show');
                setTimeout(() => {
                    dom.popover('hide');
                    setTimeout(() => {
                        dom.popover('dispose');
                    }, 500);
                }, 1000);
            },
            showErrorKotori(msg) {
                this.showError($('.popper1'), msg, 'right');
                this.showError($('.popper2'), msg, 'right');
            },
            showSuccess(dom, msg, place) {
                if (!dom.is(":visible"))
                    return;
                dom.popover({
                    content: msg,
                    placement: place,
                    template: '<div class="popover"><div class="arrow"></div>' +
                    '<div class="popover-body">' +
                    '</div></div>',
                    delay: {
                        "show": 500,
                        "hide": 500,
                    }
                });
                dom.popover('show');
                setTimeout(() => {
                    dom.popover('hide');
                    setTimeout(() => {
                        dom.popover('dispose');
                    }, 500);
                }, 1000);
            },
            setLoading() {
                this.buttonText = "";
                $('#get-url-loader').show(1);
            },
            clearLoading() {
                this.buttonText = "pw";
                $('#get-url-loader').hide(1);
            },
            urlInputOnClick() {
                if (!this.selectCooldown) {
                    this.$refs.urlInput.select();
                    this.selectCooldown = true;
                    setTimeout(() => {
                        this.selectCooldown = false;
                    }, 2000);
                }
            },
            blink(i) {
                let dom = $('#shortUrl-' + i);
                dom.removeClass("alert-success");
                dom.addClass("alert-danger");
                setTimeout(() => {
                    dom.removeClass("alert-danger");
                    dom.addClass("alert-success");
                }, 500);
            },
            getShortUrl() {
                this.setLoading();
                fetch(config.url + "?" + urlEncode(this.inputUrl, 'url', true),
                    {
                        method: 'GET',
                    }
                ).then(res => {
                    this.clearLoading();
                    switch (res.status) {
                        case 200:
                        case 400:
                            res.json().then(res => {
                                if (res.status === 'success') {
                                    this.shortUrls.push(res.shorturl);
                                } else {
                                    if (res.message.indexOf("already exists") !== -1) {
                                        let i = this.shortUrls.find(e => {
                                            return e === res.shorturl;
                                        });
                                        if (i === undefined) {
                                            this.shortUrls.push(res.shorturl);
                                        } else {
                                            this.blink(this.shortUrls.findIndex(e => {
                                                return e === i;
                                            }));
                                        }
                                    } else if (res.message.indexOf("Missing or malformed URL") !== -1) {
                                        this.showErrorKotori(this.$t('empty'));
                                    } else if (res.message.indexOf("URL is a short URL") !== -1) {
                                        this.showErrorKotori(this.$t('already'));
                                    } else {
                                        this.showErrorKotori(this.$t('unknown'));
                                    }
                                }
                            }).catch(err => {
                                console.log(err);
                                this.showError(this.$t('unknown'));
                            });
                            break;
                        case 429:
                            this.showErrorKotori(this.$t('toFast'));
                            break;
                        default:
                            this.showErrorKotori(this.$t('unknown'));
                    }

                }).catch(err => {
                    this.clearLoading();
                    console.log(err);
                })
            }
        },
        mounted() {
            this.cb = new ClipboardJS('.clipboard-a');
            this.cb.on('success', (e) => {
                this.showSuccess($(e.trigger), this.$t('copied'), 'left');
            });
            this.cb.on('error', (e) => {
                this.showError($(e.trigger), this.$t('failToCopy'), 'left');
            });
        }
    }
</script>

<style scoped>

    a {
        color: #ff7b98;
    }

    .kotori {
        min-width: 132px;
    }

    .wrapper {
        border-style: dotted;
        border-width: 0.3em;
        -webkit-border-radius: 1em;
        -moz-border-radius: 1em;
        border-radius: 1em;
        border-color: #ff7b98;

    }

    .btn-kawaii {
        background-color: #ff7b98;
    }

    .clipboard-a {
        color: darkgreen;
        float: right;
    }

    .text-kotori {
        color: #786957;
        -webkit-transition: font-size 0.5s;
        -moz-transition: font-size 0.5s;
        -ms-transition: font-size 0.5s;
        -o-transition: font-size 0.5s;
        transition: font-size 0.5s;
    }

    @media screen and (min-width: 1200px) {
        .text-kotori {
            font-size: 5em;
        }
    }

    @media screen and (min-width: 992px) and (max-width: 1200px) {
        .text-kotori {
            font-size: 4em;
        }
    }

    @media screen and (min-width: 768px) and (max-width: 992px) {
        .text-kotori {
            font-size: 3em;
        }
    }

    @media screen and (min-width: 576px) and (max-width: 768px) {
        .text-kotori {
            font-size: 2em;
        }
    }

    @media screen and (max-width: 576px) {
        .text-kotori {
            font-size: 1.5em;
        }

        .form-pc {
            margin: 1rem 0.1rem;
        }

        .form-pc button {
            margin-top: 0.2rem;
        }

        .pb-3 {
            padding-bottom: 0 !important;
        }

        .btn-kawaii {
            min-height: 2em;
        }
    }

    .url-input {

    }

    .alert-trans {
        -webkit-transition: background-color 0.5s;
        -moz-transition: background-color 0.5s;
        -ms-transition: background-color 0.5s;
        -o-transition: background-color 0.5s;
        transition: background-color 0.5s;
    }

    .loader,
    .loader:before,
    .loader:after {
        border-radius: 50%;
        width: 1em;
        height: 1em;
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both;
        -webkit-animation: load7 1.8s infinite ease-in-out;
        animation: load7 1.8s infinite ease-in-out;
    }

    .loader {
        color: #ffffff;
        font-size: 10px;
        margin: -3em auto;
        position: relative;
        text-indent: -9999em;
        -webkit-transform: translateZ(0);
        -ms-transform: translateZ(0);
        transform: translateZ(0);
        -webkit-animation-delay: -0.16s;
        animation-delay: -0.16s;
    }

    .loader:before,
    .loader:after {
        content: '';
        position: absolute;
        top: 0;
    }

    .loader:before {
        left: -1.5em;
        -webkit-animation-delay: -0.32s;
        animation-delay: -0.32s;
    }

    .loader:after {
        left: 1.5em;
    }

    @-webkit-keyframes load7 {
        0%,
        80%,
        100% {
            box-shadow: 0 2.5em 0 -1.3em;
        }
        40% {
            box-shadow: 0 2.5em 0 0;
        }
    }

    @keyframes load7 {
        0%,
        80%,
        100% {
            box-shadow: 0 2.5em 0 -1.3em;
        }
        40% {
            box-shadow: 0 2.5em 0 0;
        }
    }

</style>



// WEBPACK FOOTER //
// main.vue?1d2fcb2e